import type { NDateLocale } from './enUS'
import { enGB } from 'date-fns/locale'

const dateEnGB: NDateLocale = {
  name: 'en-GB',
  locale: enGB
}

export default dateEnGB
